import React from 'react';
import './Button.css';

const Button = ({ children, href, onClick, variant = 'primary', className = '' }) => {
  if (href) {
    return (
      <a href={href} className={`btn btn-${variant} ${className}`}>
        {children}
      </a>
    );
  }

  return (
    <button
      className={`btn btn-${variant} ${className}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default Button;
